import { Modal } from "@mui/material"
import {
  Root,
  StyledContainer,
  Title,
  ContainerBtn,
  Subtitle,
  BtnConfirm,
  BtnCancel,
} from "./styles"

interface IModalNoItems {
  open: boolean
  handleClose: () => void
  handleConfirm: () => void
  isLoading: boolean
}

export const ModalConfirmStockout = ({
  handleClose,
  open,
  handleConfirm,
  isLoading,
}: IModalNoItems) => {
  return (
    <Modal open={open}>
      <Root>
        <StyledContainer>
          <Title>Esse produto realmente acabou? </Title>
          <Subtitle>
            {" "}
            Se acabou, não iremos mais alertar a necessidade de reabastecimento desse item.{" "}
          </Subtitle>
          <ContainerBtn>
            <BtnCancel disabled={isLoading} onClick={handleClose}>
              Opa, vou ali conferir. 👀
            </BtnCancel>
            <BtnConfirm disabled={isLoading} onClick={handleConfirm}>
              Sim, acabou. 🙁
            </BtnConfirm>
          </ContainerBtn>
        </StyledContainer>
      </Root>
    </Modal>
  )
}
